<template>
    <div class="detail_unbilled_reconciliation_checklist">
        <div class="title">
            <span class="title_text">出库单编号：</span>
            <span class="title_text">{{ dataObj.id }}</span>
        </div>
        <div class="content">
            <FormSkeleton style="width: 50%;">
                <template v-slot:title>
                    <span>基础信息</span>
                </template>
                <template v-slot:content>
                    <el-form label-width="90px"
                             label-position="left">
                        <el-row :gutter="20">
                            <el-col :span="24">
                                <el-form-item label="客户名称">
                                    <!-- <el-input v-model="dataObj.receiptInfo.receiptUnit" disabled></el-input> -->
                                    <div class="form_item_underline">
                                        {{ dataObj.receiptInfo.receiptUnit }}
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </template>
            </FormSkeleton>
            <FormSkeleton style="width: 50%;">
                <template v-slot:title>
                    <span>发货信息</span>
                </template>
                <template v-slot:content>
                    <el-form label-width="90px"
                             label-position="left">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="出库类型">
                                    <div class="form_item_underline">
                                        {{ dataObj.billType }}
                                    </div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="出库时间">
                                    <div class="form_item_underline">
                                        {{ dataObj.operateTime }}
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="物流信息">
                                    <div class="form_item_underline">
                                        {{ dataObj.receiptInfo.shippingMethod }}
                                    </div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="报关发票号">
                                    <div class="form_item_underline">
                                        {{ dataObj.invoiceNo }}
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </template>
            </FormSkeleton>
        </div>
        <div class="content">
            <FormSkeleton style="width: 100%;">
                <template v-slot:title>
                    <span>发货明细</span>
                </template>
                <template v-slot:content>
                    <el-table :data="goodsList" border show-summary :summary-method="getSummaries" style="width: 100%">
                        <el-table-column prop="tableIndex" label="序号" width="80"></el-table-column>
                        <el-table-column prop="goodsNo" label="物品编号" min-width="200"></el-table-column>
                        <el-table-column prop="saleOrderNum" label="采购订单编号" width="200"></el-table-column>
                        <el-table-column prop="volumeCode" label="卷号" width="100"></el-table-column>
                        <el-table-column prop="fabricGrade" label="等级" width="100"></el-table-column>
                        <el-table-column prop="lightGrade" label="色光" width="100"></el-table-column>
                        <el-table-column prop="batchNumSource" label="缸号" width="100"></el-table-column>
                        <el-table-column prop="unit" label="单位" width="100"></el-table-column>
                        <el-table-column prop="quantity" label="数量" width="100"></el-table-column>
                    </el-table>
                </template>
            </FormSkeleton>
        </div>
    </div>
</template>

<script>
    import checkOrder from '@/mixins/order/common/CheckOrder';
    import calculate from '../../../plugins/calculate';

    export default {
        name: 'DetailUnbilledReconciliationChecklist',
        mixins: [checkOrder],
        data() {
            return {
                dataObj: {
                    receiptInfo: {}
                },
                goodsList: []
            }
        },
        beforeDestroy() {
            localStorage.removeItem('unbilledReconciliationChecklist');
        },
        methods: {
            setDefaultValue() {
                const order = JSON.parse(localStorage.getItem('unbilledReconciliationChecklist'));
                if (order.id === this.$route.params.id) {
                    this.dataObj = { ...order };
                    let count = 0;
                    this.dataObj.goods.forEach((item, index) => {
                        item.codeList.forEach(e => {
                            count += 1;
                            this.goodsList.push({
                                ...e,
                                goodsNo: item.goodsNo,
                                tableIndex: count.toString()
                            });
                        })
                        this.goodsList.push({
                            tableIndex: `小计${index + 1}`,
                            batchNumSource: `${item.pieceNum}卷`,
                            quantity: `${item.actualQuantity}`
                        });
                    });
                }
            },
            getSummaries(param) {
                const { columns, data } = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = '合计';
                        return;
                    }
                    if (index === 6) {
                        sums[index] = `${this.dataObj.goods.reduce((a, b) => calculate.add(a, b.pieceNum), 0)}卷`;
                        return;
                    }
                    if (index === 8) {
                        sums[index] = this.dataObj.goods.reduce((a, b) => calculate.add(a, b.actualQuantity), 0);
                        return;
                    }
                });
                return sums;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .detail_unbilled_reconciliation_checklist {
        .title {
            display: flex;
            justify-content: end;
            padding: 10px 20px;
            .title_text {
                font-size: 16px;
                font-weight: 700;
                color: #000;
            }
            .title_id {
                font-size: 16px;
                font-weight: 700;
                color: #02a7f0;
                text-decoration: underline;
            }
        }
        .content {
            display: flex;
            padding: 0 10px;
            .el-select {
                width: 100%;
            }
            .form_item_underline {
                height: 40px;
                border-bottom: 1px solid #000;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-weight: 700;
                display: flex;
                align-items: center;
            }
        }
        .tabs {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px 20px;
            margin: 0 20px;
            // background-color: #fff;
        }
        .tabs_table {
            padding: 0 20px;
        }
    }
</style>
